import React from 'react';
import { motion } from 'framer-motion';
export default function DashboardLoader() {
  return (
    <div style={{ padding: 16, paddingBottom: 100 }}>
      {[160, 100, 70, 80, 80, 60].map((h, i) => (
        <motion.div key={i} className="skeleton" style={{ height: h, marginBottom: 12 }}
          initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}
          transition={{ delay: i * 0.08, duration: 0.4 }} />
      ))}
    </div>
  );
}
